import { combineReducers } from 'redux'

import { extensionsProfile } from './extensions'
import { loveBrandsFiltersProfile } from './loveBrandsFilters'

export const extensionsReducer = combineReducers({
  extensionsProfile,
  loveBrandsFiltersProfile
})
